/** Compare "major.minor.patch" strings: 1 if a > b, 0 if equal, -1 if a < b. */
export function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map((p) => parseInt(p, 10) || 0);
  const pb = b.split('.').map((p) => parseInt(p, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] ?? 0, y = pb[i] ?? 0;
    if (x > y) return 1;
    if (x < y) return -1;
  }
  return 0;
}

export const isVersionOlder = (current: string, minimum: string) => compareVersions(current, minimum) < 0;

export interface VersionConfig {
  min_version: string;
  latest_version: string;
  store_url: string;
  title: string;
  message: string;
  enabled: boolean;
}

/** Below min → required (can't dismiss); below latest → optional (dismissible). */
export function decideUpdate(current: string, config: VersionConfig | null): { kind: 'none' | 'optional' | 'required' } {
  if (!config || !config.enabled || !current) return { kind: 'none' };
  if (isVersionOlder(current, config.min_version)) return { kind: 'required' };
  if (isVersionOlder(current, config.latest_version)) return { kind: 'optional' };
  return { kind: 'none' };
}
